function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs815"
}, /*#__PURE__*/React.createElement("filter", {
  id: "filter6161",
  height: 1.5,
  width: 1.5,
  y: -0.25,
  x: -0.25
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  id: "feGaussianBlur6139",
  result: "result1",
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  id: "feComposite6141",
  operator: "in",
  result: "result4",
  in2: "result1",
  in: "result1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  id: "feGaussianBlur6143",
  in: "result4",
  result: "result6",
  stdDeviation: 7
}), /*#__PURE__*/React.createElement("feComposite", {
  id: "feComposite6145",
  result: "result8",
  in2: "result4",
  in: "result6",
  operator: "over"
}), /*#__PURE__*/React.createElement("feComposite", {
  id: "feComposite6147",
  in2: "result8",
  in: "result6",
  result: "fbSourceGraphic",
  operator: "in"
}), /*#__PURE__*/React.createElement("feSpecularLighting", {
  id: "feSpecularLighting6151",
  in: "fbSourceGraphic",
  result: "result1",
  lightingColor: "rgb(255,255,255)",
  surfaceScale: 2.5,
  specularConstant: 2,
  specularExponent: 45
}, /*#__PURE__*/React.createElement("fePointLight", {
  id: "fePointLight6149",
  x: -5000,
  y: -10000,
  z: 20000
})), /*#__PURE__*/React.createElement("feComposite", {
  id: "feComposite6153",
  in2: "fbSourceGraphic",
  in: "result1",
  result: "result2",
  operator: "in"
}), /*#__PURE__*/React.createElement("feComposite", {
  id: "feComposite6155",
  in2: "result2",
  in: "fbSourceGraphic",
  result: "result4",
  operator: "arithmetic",
  k2: 1.2,
  k3: 1.5
}), /*#__PURE__*/React.createElement("feComposite", {
  id: "feComposite6157",
  result: "result9",
  in2: "result4",
  in: "result9",
  operator: "over"
}), /*#__PURE__*/React.createElement("feBlend", {
  id: "feBlend6159",
  in2: "result9",
  mode: "screen"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter6167"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  id: "feGaussianBlur6165",
  result: "blur",
  stdDeviation: "44.39 2"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clipPath1518",
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  id: "use1520"
}, /*#__PURE__*/React.createElement("g", {
  id: "g1533",
  transform: "rotate(90,39.944078,39.422088)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path1527",
  d: "m 79.79636,53.305877 c -5.023407,10e-7 -9.729887,-2.526806 -12.330077,-6.789062 -2.60019,-4.262256 -2.60019,-9.651807 0,-13.914063 2.600189,-4.262255 7.306669,-6.789062 12.330077,-6.789062 v 8.089844 c -2.30083,0 -4.363847,1.171379 -5.425779,2.912109 -1.061931,1.74073 -1.061932,3.747551 0,5.488281 1.061932,1.74073 3.124949,2.91211 5.425779,2.91211 z"
}), /*#__PURE__*/React.createElement("rect", {
  ry: 0.00000359872,
  y: 35.337124,
  x: 13.125,
  height: 7.8125,
  width: 53.4375,
  id: "rect1529"
}), /*#__PURE__*/React.createElement("path", {
  id: "path1531",
  d: "m 0.09179687,53.030486 c 5.02340963,10e-7 9.72988923,-2.526806 12.33007813,-6.789062 2.600189,-4.262256 2.600189,-9.651807 0,-13.914063 C 9.8216863,28.065106 5.1152065,25.538299 0.09179687,25.538299 v 8.089844 c 2.30083213,0 4.36384913,1.171379 5.42578123,2.912109 1.0619321,1.74073 1.0619322,3.747551 0,5.488281 -1.0619322,1.74073 -3.1249491,2.91211 -5.42578123,2.91211 z"
})))));

var _ref3 = /*#__PURE__*/React.createElement("metadata", {
  id: "metadata818"
}, /*#__PURE__*/React.createElement("useless", null, /*#__PURE__*/React.createElement("useless", {
  useless: ""
}, /*#__PURE__*/React.createElement("useless", null, "image/svg+xml"), /*#__PURE__*/React.createElement("useless", {
  useless: "http://purl.org/dc/dcmitype/StillImage"
}), /*#__PURE__*/React.createElement("useless", null))));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "layer1"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "layer4"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "g968"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-180,40.081773,39.877858)",
  id: "g1565"
}, /*#__PURE__*/React.createElement("rect", {
  ry: 0.00000359872,
  y: 36.134506,
  x: 12.60301,
  height: 7.8125,
  width: 29.582899,
  id: "rect962",
  transform: "matrix(0,1,1,0,0,0)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path964",
  d: "m 53.827867,-0.43019313 c 1e-6,5.02340963 -2.526806,9.72988923 -6.789062,12.33007813 -4.262256,2.600189 -9.651807,2.600189 -13.914063,0 C 28.862487,9.2996963 26.33568,4.5932165 26.33568,-0.43019313 h 8.089844 c 0,2.30083213 1.171379,4.36384913 2.912109,5.42578123 1.74073,1.0619321 3.747551,1.0619322 5.488281,0 1.74073,-1.0619322 2.91211,-3.1249491 2.91211,-5.42578123 z"
})));

var SvgWireSouth = function SvgWireSouth(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SVGRoot",
    viewBox: "0 0 80 80",
    height: "80px",
    width: "80px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWireSouth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wire_south.455f3174.svg";
export { ForwardRef as ReactComponent };